import * as yup from 'yup';

export const achCopyLocationSchema = yup.object().shape({
  location: yup.string().required(),
});
